import { UseMutationOptions } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import { useAppMutation } from './useAppMutation';

interface ExportParams {
  searchText?: string;
  statuses?: string[];
  facultyIds?: string[];
  courseIds?: string[];
  // Must be sent, so the export matches the grid: a missing provider means every provider server-side,
  // which would export more than the filtered view the user is looking at.
  providerId?: string;
  enrolmentDateFrom?: string;
  enrolmentDateTo?: string;
  completedDateFrom?: string;
  completedDateTo?: string;
  dueDateFrom?: string;
  dueDateTo?: string;
  expiryDateFrom?: string;
  expiryDateTo?: string;
}

export const useExportTrainingStudents = () => {
  const { mutate, isPending } = useAppMutation<AxiosResponse<Blob>, Error, any>(
    'get',
    '/TrainingManager/Export'
  );

  const exportStudents = (params: ExportParams, options: UseMutationOptions) => {
    mutate(
      {
        params: {
          searchText: params.searchText || undefined,
          statuses: params.statuses?.length ? params.statuses : undefined,
          facultyIds: params.facultyIds?.length ? params.facultyIds : undefined,
          courseIds: params.courseIds?.length ? params.courseIds : undefined,
          providerId: params.providerId,
          enrolmentDateFrom: params.enrolmentDateFrom,
          enrolmentDateTo: params.enrolmentDateTo,
          completedDateFrom: params.completedDateFrom,
          completedDateTo: params.completedDateTo,
          dueDateFrom: params.dueDateFrom,
          dueDateTo: params.dueDateTo,
          expiryDateFrom: params.expiryDateFrom,
          expiryDateTo: params.expiryDateTo,
        },
        paramsSerializer: { indexes: null },
      },
      {
        ...options,
      }
    );
  };

  return { exportStudents, isPending };
};
